/**
 * Blog search - navigates to search page on submit (no inline predictive search).
 * Form submits normally; results display on /search page.
 */
class BlogSearchInline extends HTMLElement {
  constructor() {
    super();
    this.form = this.querySelector('form');
    if (this.form) {
      this.form.addEventListener('submit', (e) => {
        const input = this.querySelector('input[name="q"]');
        if (input && !input.value.trim()) {
          e.preventDefault();
        }
      });
    }
  }
}

customElements.define('blog-search-inline', BlogSearchInline);
